import React, { Component } from "react";
import { ContentGrid, ContentGridTable } from "./styles";

class GridTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: this.props.columns,
      dados: this.props.dados,
      footer: this.props.footer,

      linha_selecionada: [],
    };
  }

  selecionaLinha = (e) => {
    const { linha_selecionada } = this.state;
    const value = parseInt(e.currentTarget.getAttribute('id'));
  
    let linha_selecionada_atualizada;
    
    if (linha_selecionada.includes(value)) {
      linha_selecionada_atualizada = linha_selecionada.filter(data => data !== value);
    } else {
      linha_selecionada_atualizada = [...linha_selecionada, value];
    }
  
    this.setState({ linha_selecionada: linha_selecionada_atualizada });
  };

  ifnull = (a, b) => {
    if (a == null || a == undefined || a == "") {
      return b;
    } else {
      return a;
    }
  };

  render() {
    const { columns, dados, linha_selecionada, footer } = this.state;

    return (
      <ContentGrid>
        <ContentGridTable>
          <table border="0" style={{ width: columns.length * 150 + "px" }}>
            <thead>
              {columns.map((data) => {
                return (
                  <th style={this.ifnull(data.css, {})}>
                    <div>
                      <p>{data.text}</p>
                    </div>
                  </th>
                );
              })}
            </thead>
            <tbody>
              {dados.map((data, idx) => {
                return (
                  <tr>
                    {columns.map((col) => {
                      if (col.dataField.trim() != "") {
                        var valor = eval("data." + col.dataField);
                      } else {
                        var valor = "";
                      }

                      return (
                        <td
                          style={
                            linha_selecionada.includes(idx + 1)
                              ? {
                                  backgroundColor: "#3aa7de",
                                  color: "white",
                                }
                              : {}
                          }
                        >
                          <div
                            style={
                              linha_selecionada.includes(idx + 1)
                                ? {
                                    backgroundColor: "#3aa7de",
                                    color: "white",
                                  }
                                : {}
                            }
                            id={idx + 1}
                            onClick={(e) => this.selecionaLinha(e)}
                          >
                            {col.formatExtraData != undefined ? (
                              col.legend != undefined ? (
                                <div>
                                  {idx == 0 ? (
                                    col.formatterLegend(
                                      valor,
                                      col.formatExtraData
                                    )
                                  ) : (
                                    <></>
                                  )}
                                  {col.formatter(valor, col.formatExtraData)}
                                </div>
                              ) : (
                                col.formatter(
                                  valor,
                                  col.formatExtraData,
                                  col.exec_function,
                                  JSON.stringify(data)
                                )
                              )
                            ) : col.element != undefined ? (
                              col.element
                            ) : (
                              <p
                                style={
                                  linha_selecionada.includes(idx + 1)
                                    ? {
                                        backgroundColor: "#3aa7de",
                                        color: "white",
                                      }
                                    : {}
                                }
                              >
                                {col.formatter != undefined
                                  ? col.formatter(valor)
                                  : valor}
                              </p>
                            )}
                          </div>
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </ContentGridTable>
      </ContentGrid>
    );
  }
}

export default GridTable;
